import React from 'react';
import Contact from './components/contact/Contact';
import Experience from './components/experience/Experience';
import Footer from './components/footer/Footer';
import Header from './components/header/Header';
import Intro from './components/intro/Intro';
import Portfolio from './components/portfolio/Portfolio';
import Topbar from './components/topbar/Topbar';
import Coding from './components/Coding/Coding';
import Certificates from './components/Certificates/Certificates';


const App = () => {
  return (
    <>
      <Header />
      <Topbar />
      <Intro />
      <Experience />
      <Coding/>
      <Portfolio />
      <Certificates/>
      <Contact />
      <Footer />
    </>
  )
}

export default App
